import React from 'react';
import { useSelector } from 'react-redux';

import { OPZET_API_URL } from '../config/constants';
import { RootState } from '../store/reducers';

const useICalUrl = () => {
  const bagid = useSelector((state: RootState) => state.geolocation.selected?.bagid);

  return React.useMemo(() => {
    return bagid ? `${OPZET_API_URL}/ical/${bagid}` : null;
  }, [bagid]);
};

export default useICalUrl;
